import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.min.css';
import 'froala-editor/css/plugins/image.min.css';

type Props = { content?: string };

/**
 * FroalaContent.
 */
const FroalaContent = (props: Props): JSX.Element => {
  const { content = '' } = props;
  return (
    <Box
      className="fr-view p-3 pb-0 text-sm"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default FroalaContent;
